//dawn
VGTierApp.CartPage.Show_CalculateTier = function () {

    var cartItemsCart = commonFields_CD.cartItemsCart, variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;

    var TieredPricingCart = function (cartItems, isUpdate) {
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updated_total_price = 0;
        commonFields_CD.original_total_price = 0;
        for (k = 0; k < cartItems.length; k++) {
            var item = cartItems[k], isInRange = true; item.original_line_price = item.original_price * item.quantity; item.original_line_price = Number(item.original_line_price.toFixed(2));
            if (item.tiers != "" && item.tiers.split(',')[5] === 'true' && globalFields.StartEndDateValid(item.tiers.split(','))) {
                var rslt = CalculateTier(item.original_price, item.original_line_price, item.quantity, item.tiers.split(','), updated_total_price, isUpdate, true, k, cartItems, item.variant_id);
                updated_total_price = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                    updated_total_price += item.original_line_price;
                }
            }
            else {
                updated_total_price += item.original_line_price;
            }
            if (!isInRange) {
                minimumDiscountSubtotal += item.original_line_price; variantIdsToSend.push(item.variant_id);
            }
            commonFields_CD.original_total_price += item.original_line_price;
        }
        commonFields_CD.original_total_price = Number(commonFields_CD.original_total_price.toFixed(2));
        UpdateCartSubtotal(isUpdate, Number(updated_total_price.toFixed(2)), commonFields_CD.original_total_price);
        priceDiff = Number((commonFields_CD.original_total_price - updated_total_price).toFixed(2));
        UpdateSavingMessage(isUpdate); cartItemsCart = cartItems;
    }

    var CalculateTier = function (original_price, original_line_price, quantity, splitTierPricing, updated_total_price, isUpdate, isNotInRange, index, cartItems, variant_id) {
        var updated_line_price = 0;
        for (i = 6; i < splitTierPricing.length; i++) {
            var createdOn = splitTierPricing[1].split('-')[0], createdOnId = splitTierPricing[1].split('-')[1], allVariantItemQty = 0;
            var tierRange = splitTierPricing[i].split('=')[0], tierPrice = splitTierPricing[i].split('=')[1];
            var minTier = parseInt(tierRange.split("-")[0]), maxTier = tierRange.split("-")[1] != 'max' ? parseInt(tierRange.split("-")[1]) : tierRange.split("-")[1];
            var updated_price = 0, condition1 = false, condition2 = false;

            if (createdOn === 'product' || createdOn === 'collection') {
                var arr = createdOn === 'product' ? jQuery.grep(cartItems, function (n) { return (n.product_id === createdOnId); }) : jQuery.grep(cartItems, function (n) { return (n.collection_id === createdOnId); });
                for (j = 0; j < arr.length; j++) { allVariantItemQty += arr[j].quantity; }
                if (allVariantItemQty >= minTier) { condition1 = true; }
                if (maxTier == "max") { condition2 = true; }
                else if (allVariantItemQty <= maxTier) { condition2 = true; }
            }
            else {
                if (quantity >= minTier) { condition1 = true; }
                if (maxTier == "max") { condition2 = true; }
                else if (quantity <= maxTier) { condition2 = true; }
            }

            if (condition1 && condition2) {
                isNotInRange = false;
                if (splitTierPricing[0].trim() == 'percentage') {
                    var originalPriceCut = Number((parseFloat((parseFloat(tierPrice) / 100) * original_price)).toFixed(2));
                    updated_price = Number((original_price - originalPriceCut).toFixed(2));
                }
                else if (splitTierPricing[0].trim() == 'fixed') {
                    updated_price = Number((original_price - parseFloat(tierPrice)).toFixed(2));
                }
                else if (splitTierPricing[0].trim() == 'fixed_price') {
                    updated_price = Number((parseFloat(tierPrice)).toFixed(2));
                }

                if (updated_price < 0) { updated_price = 0; }
                updated_line_price = Number((updated_price * quantity).toFixed(2))
                updated_total_price += updated_line_price;
                UpdateCartItem(isUpdate, updated_price, updated_line_price, index, variant_id, original_price, original_line_price, isNotInRange, cartItems[index].productId);
            }
        }
        if (isNotInRange) {
            UpdateCartItem(isUpdate, original_price, original_line_price, index, variant_id, original_price, original_line_price, isNotInRange, cartItems[index].productId);
        }
        return [updated_total_price, isNotInRange];
    }

    var UpdateCartItem = function (isUpdate, updated_price, updated_line_price, index, variantId, original_price, original_line_price, isNotInRange, productId) {
        if (isUpdate) {
            if (isNotInRange || (updated_price == original_price)) {
                jQuery('.cart-item').eq(index).find('.product-option:eq(0)').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updated_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + updated_price.toFixed(2) + '</span>');
                jQuery('.cart-item').eq(index).find('.cart-item__price-wrapper').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updated_line_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + updated_line_price.toFixed(2) + '</span>');
            }
            else {
                jQuery('.cart-item').eq(index).find('.product-option:eq(0)').html('<p style="padding-left: 10%;margin-bottom:5px" class="cart-item__original-price"><small><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + original_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + original_price.toFixed(2) + '</span></s></small></p> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updated_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + updated_price.toFixed(2) + '</span>');
                jQuery('.cart-item').eq(index).find('.cart-item__price-wrapper').html('<p style="margin-bottom:5px" class="cart-item__original-price"><small><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + original_line_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + original_line_price.toFixed(2) + '</span></s></small></p> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updated_line_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + updated_line_price.toFixed(2) + '</span>');
            }
        }
    }

    var UpdateCartSubtotal = function (isUpdate, updated_total_price, original_total_price) {
        if (isUpdate) {
            if (original_total_price != updated_total_price) {
                jQuery('.totals__subtotal-value,.totals__total-value').html('<small><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + original_total_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + original_total_price.toFixed(2) + '</span></s></small> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updated_total_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + updated_total_price.toFixed(2) + '</span>');
            }
            else {
                jQuery('.totals__subtotal-value,.totals__total-value').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updated_total_price.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + updated_total_price.toFixed(2) + '</span>');
            }
        }
    }

    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveHtml = '<h3 id="saved-banner">' + jQuery('#vg-saving-message').text() + ' <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.currencySymbol + priceDiff.toFixed(2) + '</span></h3>';
            jQuery('#saved-banner-div').length == 0 ? jQuery('form.cart').before('<div id="saved-banner-div" class="col-md-12">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }

    var CheckoutClickCart = function () {
        jQuery('button[name="checkout"]').click(function () {
          console.log("checkoutclick")
            jQuery('[name="updates[]"]').each(function () {
                var qtyValue = this.value; var idAtrbtValue = jQuery(this).attr('data-quantity-variant-id'); //idAtrbtValue = idAtrbtValue.split('_'); idAtrbtValue = idAtrbtValue[1];
                idAtrbtValue = idAtrbtValue.split(':'); idAtrbtValue = idAtrbtValue[0];
                for (i = 0; i < cartItemsCart.length; i++) {
                    if (cartItemsCart[i].variant_id == Number(idAtrbtValue)) { cartItemsCart[i].quantity = Number(qtyValue); }
                }
            });
            TieredPricingCart(cartItemsCart, false);
            GetCode(false);
        });
    }

    var CheckoutClickAjax = function () {
        jQuery('#ajaxifyCart form.cart-wrapper button[name="checkout"]').click(function (e) {
            //e.preventDefault();
            GetCode(true);
        });
    }

    var GetCode = function (isUpper) {
        if (priceDiff > 0) {
            $.ajax({
                type: "POST", async: false, url: "https://www.vgroupapps.com/TieredPricing/api/services/GetCode",
                data: { priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString() },
                success: function (result) {
                    var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                    if (!isUpper) {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                    } else {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                        //window.location.href = '/checkout?discount=' + DiscountCode;
                    }
                },
                error: function (e) { console.log(e.statusText); }
            });
        }
    }

    var DiscountCodeCookie = function (discount_code) {
        $.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchMetafield = function (productHandle, variant_id) {
        var variantMF = "";
        if (commonFields_CD.variantsMFArray.hasOwnProperty(variant_id)) {
            variantMF = commonFields_CD.variantsMFArray[variant_id];
        }
        else if (globalFields.isProductPage && commonFields_PD.variantsMFArray_PD.hasOwnProperty(variant_id)) {
            variantMF = commonFields_PD.variantsMFArray_PD[variant_id];
        }
        else {
            jQuery.ajax({
                async: false,
                url: "/products/" + productHandle + "?view=vgmetafields",
                success: function (result) {
                    var data_ = JSON.parse(result);
                    for (var k = 0; k < data_.length; k++) {
                        var variantMetafieldChoosen = data_[k];
                        if (variantMetafieldChoosen.variantId === variant_id) {
                            if (variantMetafieldChoosen.tiers.hasOwnProperty('tieredpricing')) {
                                variantMF = variantMetafieldChoosen.tiers['tieredpricing'];
                            }
                            break;
                        }
                    }
                },
                error: function (e) { console.log(e.statusText); }
            });
        }
        return variantMF;
    }

    /*
    var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
    function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
    function sendReplacement(data) {
        this.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                ProcessCartResponse(this._url, this.responseText);
            }
        };
        return send.apply(this, arguments);
    }
    window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */

try{
      
        var nativeFetch = window.fetch;
        window.fetch = function(...args) {
          
          if(args[0].includes("/cart/change") || args[0].includes("/cart/add") ){
            setTimeout(function () {
              
              fetch('/cart.js')
              .then(r =>  r.json().then(data => ({status: r.status, body: data})))
              .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
            }, 500);
          }
          return nativeFetch.apply(window, args);
        }
      }
      catch(e){}
  
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
      console.log("code ")
        ProcessCartResponse(settings.url, xhr.responseText);
    });

    function ProcessCartResponse(splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                var response = JSON.parse(responseText);
                setTimeout(function () {
                    var cartItemsCart_temp = cartItemsCart; cartItemsCart = [];
                    commonFields_CD.original_total_price = Number((response.original_total_price / 100).toFixed(2));
                    for (var i = 0; i < response.items.length; i++) {
                        var item = response.items[i];
                        var original_price = Number((item.original_price / 100).toFixed(2)), original_line_price = Number((item.original_line_price / 100).toFixed(2));
                        var item_temp = jQuery.grep(cartItemsCart_temp, function (n) { return (n.variant_id === item.variant_id); });
                        var tiers = item_temp.length != 0 ? item_temp[0].tiers : FetchMetafield(item.handle, item.variant_id);
                        var collection_id = tiers != "" && tiers.split(',')[1].split('-')[0] === 'collection' ? tiers.split(',')[1].split('-')[1] : 0;
                        var item1 = { variant_id: item.variant_id, tiers: tiers, original_price: original_price, original_line_price: original_line_price, quantity: item.quantity, product_id: (item.product_id).toString(), collection_id: collection_id };
                        cartItemsCart.push(item1);
                    }
                    TieredPricingCart(cartItemsCart, true);
                    jQuery('#ajaxifyCart form.cart-wrapper button[name="checkout"]').off("click"); CheckoutClickCart(); CheckoutClickAjax();
                }, 500);
            }
        }
    }

    function SetCookie(cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    TieredPricingCart(cartItemsCart, true); CheckoutClickCart(); CheckoutClickAjax();
}

var commonFields_CD = new VGTierApp.CartPage.Global(); var cartObject = new VGTierApp.CartPage.Show_CalculateTier();